import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../services/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-plan-result',
  templateUrl: './plan-result.component.html',
  styleUrls: ['./plan-result.component.css']
})
export class PlanResultComponent implements OnInit {

  maximized: boolean = false;
  admin_data: any;
  years: any; //all year
  years_select: any; //data from select year
  type_select: any = "mont"; //data from select mont/quarter
  //plan
  plan_all: any;
  data_plan = {
    plan_principle: [] as any,
    plan_revenue: [] as any,
    plan_expend: [] as any,
    plan_last: [] as any,
  };
  total_income = {
    oct: 0,
    nov: 0,
    dec: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    sumRow: 0,
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0
  }
  total_expenses = {
    oct: 0,
    nov: 0,
    dec: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    sumRow: 0,
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0
  }
  income_expenses = {
    oct: 0,
    nov: 0,
    dec: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    sumRow: 0,
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0
  }

  //result
  result_all: any;
  data_result = {
    principle: [] as any,
    revenue: [] as any,
    expend: [] as any,
    last: [] as any,
  };
  rs_total_income = {
    oct: 0,
    nov: 0,
    dec: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    sumRow: 0,
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0
  }
  rs_total_expenses = {
    oct: 0,
    nov: 0,
    dec: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    sumRow: 0,
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0
  }
  rs_income_expenses = {
    oct: 0,
    nov: 0,
    dec: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    sumRow: 0,
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0
  }

  sumCol: any;
  //edit data form
  edit_data = {
    fiscal_year: '',
    type1: '',
    type2: '',
    type3: '',
    oct: 0,
    nov: 0,
    dec: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    status: '',
    user_id: 0,
    id_plan: 0,
  }
  principle = {
    id: ''
  }
  last = {
    id: ''
  }
  //new data form
  btn_new: boolean = false
  btn_newLoan: boolean = false
  new_data = {
    fiscal_year: '',
    type1: '',
    type2: '',
    type3: '',
    oct: 0,
    nov: 0,
    dec: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    status: 'Enable',
    user_id: 0,
    id_plan: 0,
  }

  btn_plan: boolean = false
  btn_result: boolean = false
  isDisplayMont = true;
  isDisplayQuarter = false;

  enableEdit = false;
  enableEditIndex = null;
  enableEditI = null;

  constructor(
    public services: ApiService
  ) { }

  ngOnInit(): void {
    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
    this.getDataAll();
    this.createSumCol('รวมรายรับเงินงบประมาณ');
    document.getElementById('plans')!.classList.toggle("active");
    document.getElementById('plan')!.classList.toggle("show");
    document.getElementById('plan_result')!.classList.toggle("active");
    this.new_data.user_id = Number(this.admin_data.id)
  }

  ngOnDestroy() {
    document.getElementById('plans')!.classList.remove("active");
    document.getElementById('plan')!.classList.remove("show");
    document.getElementById('plan_result')!.classList.remove("active");
  }


  //get data(table m_plan, m_result) from api
  async getDataAll() {
    let plan_all = [] as any;
    let result_all = [] as any;
    await this.services.get('m_plan').then((res: any) => {
      res.forEach((plan: any) => {
        if (plan.status == 'Enable') {
          plan_all.push(plan);
        }
      });
      plan_all = plan_all.sort((a: any, b: any) => (a.id < b.id) ? -1 : ((b.id < a.id) ? 1 : 0))
      this.getPlan(plan_all);
    });
    await this.services.get('m_result').then((res: any) => {
      res.forEach((result: any) => {
        if (result.status == 'Enable') {
          result_all.push(result);
        }
      });
      result_all = result_all.sort((a: any, b: any) => (a.id < b.id) ? -1 : ((b.id < a.id) ? 1 : 0))
      this.getResult(result_all);
    });
  }
  async select_year() {
    let plan_all = [] as any;
    let resule_all = [] as any;

    this.services.get('m_plan').then((res: any) => {
      this.plan_all = res.filter((f:any)=>{
        return f.status.toLowerCase() == 'enable'
      });
    })
    this.services.get('m_result').then((res: any) => {
      this.result_all = res.filter((f:any)=>{
        return f.status.toLowerCase() == 'enable'
      });
    })

    //เก็บข้อมูลตามปีงบประมาณที่เลือก
    let plan_select = [] as any;
    let resule_select = [] as any;
    //filter ข้อมูลตามปีงบประมาณที่เลือก
    plan_select = this.plan_all.filter((f:any)=>{
      return f.fiscal_year == this.years_select
    })
    resule_select = this.result_all.filter((f:any)=>{
      return f.fiscal_year == this.years_select
    })
    this.calculate_plan(await plan_select);
    this.calculate_resule(await resule_select);
  }
  //get data to variable years, data_plan
  getPlan(data: any) {
    let year = [] as any;
    //create year for selecter
    data.forEach((data: any) => {
      year.push(data.fiscal_year);
    });
    this.years = [...new Set(year)].sort();
    this.years_select = Number(new DatePipe('en-US').transform(new Date(), 'yyyy')!) + 543;
    this.plan_all = data;

    let plan_select = [] as any;
    //filter ข้อมูลตามปีงบประมาณที่เลือก
    plan_select = this.plan_all.filter((f:any)=>{
      return f.fiscal_year == this.years_select
    })
    this.calculate_plan(plan_select);
  }
  //get data to resule_all
  getResult(data: any) {
    this.result_all = data;
    let result_select = [] as any;
    //filter ข้อมูลตามปีงบประมาณที่เลือก
    result_select = this.result_all.filter((f:any)=>{
      return f.fiscal_year == this.years_select
    })
    this.calculate_resule(result_select);
  }

  //คำนวนผลรวม แผน
  calculate_plan(plan_select: any) {
    this.total_income = {
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      sumRow: 0,
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0
    }
    this.total_expenses = {
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      sumRow: 0,
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0
    }
    this.income_expenses = {
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      sumRow: 0,
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0
    }
    if (plan_select.length > 0) {
      //เงินต้นงวด
      let plan_principle = [] as any;
      //รายรับ
      let plan_revenue = {
        budget: [] as any,
        incom: [] as any,
        lr: [] as any
      };
      //รายจ่าย
      let plan_expend = {
        invest: {
          loan: [] as any,
          sup: [] as any
        },
        personal: [] as any,
        oper: [] as any,
        out: [] as any
      };
      //เงินปลายงวด
      let plan_last = [] as any;
      //ผลรวมแนวนอน (แถว)
      let sumRow: any;
      //แยกข้อมูลเข้าตัวแปรแต่ละประเภท
      plan_select.forEach((data: any) => {
        sumRow = [Number(data.oct), Number(data.nov), Number(data.dec), Number(data.jan), Number(data.feb), Number(data.mar),
        Number(data.apr), Number(data.may), Number(data.jun), Number(data.jul), Number(data.aug), Number(data.sep)].reduce((a, b) => a + b, 0);
        data.sumRow = this.fixDecimal(sumRow);
        this.calQuarter(data);
        if (data.type1 == 'เงินต้นงวด') {
          plan_principle.push(data);
        } else if (data.type1 == 'รายรับ') {
          switch (data.type2) {
            case 'เงินงบประมาณ': {
              plan_revenue.budget.push(data);
              break;
            }
            case 'รายรับจากการดำเนินงาน': {
              plan_revenue.incom.push(data);
              break;
            }
            default: {
              plan_revenue.lr.push(data);
              break;
            }
          }
        } else if (data.type1 == 'รายจ่าย') {
          switch (data.type2) {
            case 'เงินกู้ยืม/อุดหนุน': {
              plan_expend.invest.loan.push(data);
              break;
            }
            case 'เงินให้สนับสนุน': {
              plan_expend.invest.sup.push(data);
              break;
            }
            case 'ค่าใช้จ่ายบุคลากร': {
              plan_expend.personal.push(data);
              break;
            }
            case 'ค่าใช้จ่ายดำเนินงาน': {
              plan_expend.oper.push(data);
              break;
            }
            case 'ค่าใช้จ่ายอื่น': {
              plan_expend.out.push(data);
              break;
            }
            default: {
              break;
            }
          }
        } else {
          plan_last.push(data);
        }
      });

      plan_principle.forEach((data: any) => {
        this.fixNumber(data);
      });
      plan_last.forEach((data: any) => {
        this.fixNumber(data);
      });
      //รวมรายรับ
      plan_revenue.budget.forEach((data: any) => {
        this.calSumCol(data);
      });
      plan_revenue.budget.push(this.sumCol);
      this.sum_total_income(this.sumCol);
      plan_revenue.budget.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมรายรับจากการดำเนินงาน')
      plan_revenue.incom.forEach((data: any) => {
        this.calSumCol(data);
      });
      plan_revenue.incom.push(this.sumCol);
      this.sum_total_income(this.sumCol);
      plan_revenue.incom.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมเงินรับคืนและรายรับอื่นจากโครงการจัดรูปฯ')
      plan_revenue.lr.forEach((data: any) => {
        this.calSumCol(data);
      });
      plan_revenue.lr.push(this.sumCol);
      this.sum_total_income(this.sumCol);
      plan_revenue.lr.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมเงินลงทุน')
      //รวมรายจ่าย
      plan_expend.invest.loan.forEach((data: any) => {
        this.calSumCol(data);
      });
      plan_expend.invest.loan.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      plan_expend.invest.sup.forEach((data: any) => {
        this.calSumCol(data);
      });
      plan_expend.invest.sup.push(this.sumCol);
      this.sum_total_expenses(this.sumCol);
      plan_expend.invest.sup.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมค่าใช้จ่ายบุคลากร')
      plan_expend.personal.forEach((data: any) => {
        this.calSumCol(data);
      });
      plan_expend.personal.push(this.sumCol);
      this.sum_total_expenses(this.sumCol);
      plan_expend.personal.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมค่าใช้จ่ายดำเนินงาน')

      plan_expend.oper.forEach((data: any) => {
        this.calSumCol(data);
      });
      plan_expend.oper.push(this.sumCol);
      this.sum_total_expenses(this.sumCol);
      plan_expend.oper.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมค่าใช้จ่ายอื่น')
      plan_expend.out.forEach((data: any) => {
        this.calSumCol(data);
      });
      plan_expend.out.push(this.sumCol);
      this.sum_total_expenses(this.sumCol);
      plan_expend.out.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมรายรับเงินงบประมาณ')
      this.data_plan.plan_principle = plan_principle;
      this.data_plan.plan_revenue = plan_revenue;
      this.data_plan.plan_expend = plan_expend;
      this.data_plan.plan_last = plan_last;
      //คำนวณ รายรับ - รายจ่าย
      this.income_expenses.oct = this.total_income.oct - this.total_expenses.oct;
      this.income_expenses.nov = this.total_income.nov - this.total_expenses.nov;
      this.income_expenses.dec = this.total_income.dec - this.total_expenses.dec;
      this.income_expenses.jan = this.total_income.jan - this.total_expenses.jan;
      this.income_expenses.feb = this.total_income.feb - this.total_expenses.feb;
      this.income_expenses.mar = this.total_income.mar - this.total_expenses.mar;
      this.income_expenses.apr = this.total_income.apr - this.total_expenses.apr;
      this.income_expenses.may = this.total_income.may - this.total_expenses.may;
      this.income_expenses.jun = this.total_income.jun - this.total_expenses.jun;
      this.income_expenses.jul = this.total_income.jul - this.total_expenses.jul;
      this.income_expenses.aug = this.total_income.aug - this.total_expenses.aug;
      this.income_expenses.sep = this.total_income.sep - this.total_expenses.sep;
      this.income_expenses.sumRow = this.total_income.sumRow - this.total_expenses.sumRow;
      this.income_expenses.q1 = this.total_income.q1 - this.total_expenses.q1;
      this.income_expenses.q2 = this.total_income.q2 - this.total_expenses.q2;
      this.income_expenses.q3 = this.total_income.q3 - this.total_expenses.q3;
      this.income_expenses.q4 = this.total_income.q4 - this.total_expenses.q4;
      this.fixNumber(this.total_income);
      this.fixNumber(this.total_expenses);
      this.fixNumber(this.income_expenses);
    }
  }
  //คำนวณรวมรายรับทั้งสิ้น
  sum_total_income(data: any) {
    this.total_income.oct += Number(data.oct);
    this.total_income.nov += Number(data.nov);
    this.total_income.dec += Number(data.dec)
    this.total_income.jan += Number(data.jan)
    this.total_income.feb += Number(data.feb)
    this.total_income.mar += Number(data.mar)
    this.total_income.apr += Number(data.apr)
    this.total_income.may += Number(data.may)
    this.total_income.jun += Number(data.jun)
    this.total_income.jul += Number(data.jul)
    this.total_income.aug += Number(data.aug)
    this.total_income.sep += Number(data.sep)
    this.total_income.sumRow += Number(data.sumRow)
    this.total_income.q1 += Number(data.q1)
    this.total_income.q2 += Number(data.q2)
    this.total_income.q3 += Number(data.q3)
    this.total_income.q4 += Number(data.q4)
  }
  //คำนวณรวมรายจ่ายทั้งสิ้น
  sum_total_expenses(data: any) {
    this.total_expenses.oct += Number(data.oct),
      this.total_expenses.nov += Number(data.nov)
    this.total_expenses.dec += Number(data.dec)
    this.total_expenses.jan += Number(data.jan)
    this.total_expenses.feb += Number(data.feb)
    this.total_expenses.mar += Number(data.mar)
    this.total_expenses.apr += Number(data.apr)
    this.total_expenses.may += Number(data.may)
    this.total_expenses.jun += Number(data.jun)
    this.total_expenses.jul += Number(data.jul)
    this.total_expenses.aug += Number(data.aug)
    this.total_expenses.sep += Number(data.sep)
    this.total_expenses.sumRow += Number(data.sumRow)
    this.total_expenses.q1 += Number(data.q1)
    this.total_expenses.q2 += Number(data.q2)
    this.total_expenses.q3 += Number(data.q3)
    this.total_expenses.q4 += Number(data.q4)
  }

  //ผล
  //คำนวนผลรวม ผล
  async calculate_resule(result_select: any) {
    this.rs_total_income = {
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      sumRow: 0,
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0
    }
    this.rs_total_expenses = {
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      sumRow: 0,
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0
    }
    this.rs_income_expenses = {
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      sumRow: 0,
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0
    }
    if (result_select.length > 0) {
      //เงินต้นงวด
      let rs_principle = [] as any;
      //รายรับ
      let rs_revenue = {
        budget: [] as any,
        incom: [] as any,
        lr: [] as any
      };
      //รายจ่าย
      let rs_expend = {
        invest: {
          loan: [] as any,
          sup: [] as any
        },
        personal: [] as any,
        oper: [] as any,
        out: [] as any
      };
      //เงินปลายงวด
      let rs_last = [] as any;
      //ผลรวมแนวนอน (แถว)
      let sumRow: any;
      //แยกข้อมูลเข้าตัวแปรแต่ละประเภท
      result_select.forEach((data: any) => {
        sumRow = [Number(data.oct), Number(data.nov), Number(data.dec), Number(data.jan), Number(data.feb), Number(data.mar),
        Number(data.apr), Number(data.may), Number(data.jun), Number(data.jul), Number(data.aug), Number(data.sep)].reduce((a, b) => a + b, 0);
        data.sumRow = this.fixDecimal(sumRow);
        this.calQuarter(data);
        if (data.type1 == 'เงินต้นงวด') {
          rs_principle.push(data);
        } else if (data.type1 == 'รายรับ') {
          switch (data.type2) {
            case 'เงินงบประมาณ': {
              rs_revenue.budget.push(data);
              break;
            }
            case 'รายรับจากการดำเนินงาน': {
              rs_revenue.incom.push(data);
              break;
            }
            default: {
              rs_revenue.lr.push(data);
              break;
            }
          }
        } else if (data.type1 == 'รายจ่าย') {
          switch (data.type2) {
            case 'เงินกู้ยืม/อุดหนุน': {
              rs_expend.invest.loan.push(data);
              break;
            }
            case 'เงินให้สนับสนุน': {
              rs_expend.invest.sup.push(data);
              break;
            }
            case 'ค่าใช้จ่ายบุคลากร': {
              rs_expend.personal.push(data);
              break;
            }
            case 'ค่าใช้จ่ายดำเนินงาน': {
              rs_expend.oper.push(data);
              break;
            }
            case 'ค่าใช้จ่ายอื่น': {
              rs_expend.out.push(data);
              break;
            }
            default: {
              break;
            }
          }
        } else {
          rs_last.push(data);
        }
      });


      //รวมรายรับ
      rs_revenue.budget.forEach((data: any) => {
        this.calSumCol(data);
      });
      rs_revenue.budget.push(this.sumCol);
      await this.sum_rs_income(this.sumCol);
      rs_revenue.budget.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมรายรับจากการดำเนินงาน')
      rs_revenue.incom.forEach((data: any) => {
        this.calSumCol(data);
      });
      rs_revenue.incom.push(this.sumCol);
      await this.sum_rs_income(this.sumCol);
      rs_revenue.incom.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมเงินรับคืนและรายรับอื่นจากโครงการจัดรูปฯ')
      rs_revenue.lr.forEach((data: any) => {
        this.calSumCol(data);
      });
      rs_revenue.lr.push(this.sumCol);
      await this.sum_rs_income(this.sumCol);
      rs_revenue.lr.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมเงินลงทุน')
      //รวมรายจ่าย
      rs_expend.invest.loan.forEach((data: any) => {
        this.calSumCol(data);
      });
      rs_expend.invest.loan.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      rs_expend.invest.sup.forEach((data: any) => {
        this.calSumCol(data);
      });
      rs_expend.invest.sup.push(this.sumCol);
      await this.sum_rs_expenses(this.sumCol);
      rs_expend.invest.sup.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมค่าใช้จ่ายบุคลากร')
      rs_expend.personal.forEach((data: any) => {
        this.calSumCol(data);
      });
      rs_expend.personal.push(this.sumCol);
      await this.sum_rs_expenses(this.sumCol);
      rs_expend.personal.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมค่าใช้จ่ายดำเนินงาน')

      rs_expend.oper.forEach((data: any) => {
        this.calSumCol(data);
      });
      rs_expend.oper.push(this.sumCol);
      await this.sum_rs_expenses(this.sumCol);
      rs_expend.oper.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมค่าใช้จ่ายอื่น')
      rs_expend.out.forEach((data: any) => {
        this.calSumCol(data);
      });
      rs_expend.out.push(this.sumCol);
      await this.sum_rs_expenses(this.sumCol);
      rs_expend.out.forEach((datas: any) => {
        this.fixNumber(datas);
      });
      this.createSumCol('รวมรายรับเงินงบประมาณ')
      this.data_result.principle = rs_principle;
      this.data_result.revenue = rs_revenue;
      this.data_result.expend = rs_expend;
      this.data_result.last = rs_last;

      //คำนวณ รายรับ - รายจ่าย
      this.rs_income_expenses.oct = this.rs_total_income.oct - this.rs_total_expenses.oct;
      this.rs_income_expenses.nov = this.rs_total_income.nov - this.rs_total_expenses.nov;
      this.rs_income_expenses.dec = this.rs_total_income.dec - this.rs_total_expenses.dec;
      this.rs_income_expenses.jan = this.rs_total_income.jan - this.rs_total_expenses.jan;
      this.rs_income_expenses.feb = this.rs_total_income.feb - this.rs_total_expenses.feb;
      this.rs_income_expenses.mar = this.rs_total_income.mar - this.rs_total_expenses.mar;
      this.rs_income_expenses.apr = this.rs_total_income.apr - this.rs_total_expenses.apr;
      this.rs_income_expenses.may = this.rs_total_income.may - this.rs_total_expenses.may;
      this.rs_income_expenses.jun = this.rs_total_income.jun - this.rs_total_expenses.jun;
      this.rs_income_expenses.jul = this.rs_total_income.jul - this.rs_total_expenses.jul;
      this.rs_income_expenses.aug = this.rs_total_income.aug - this.rs_total_expenses.aug;
      this.rs_income_expenses.sep = this.rs_total_income.sep - this.rs_total_expenses.sep;
      this.rs_income_expenses.sumRow = this.rs_total_income.sumRow - this.rs_total_expenses.sumRow;
      this.rs_income_expenses.q1 = this.rs_total_income.q1 - this.rs_total_expenses.q1;
      this.rs_income_expenses.q2 = this.rs_total_income.q2 - this.rs_total_expenses.q2;
      this.rs_income_expenses.q3 = this.rs_total_income.q3 - this.rs_total_expenses.q3;
      this.rs_income_expenses.q4 = this.rs_total_income.q4 - this.rs_total_expenses.q4;


      this.principle_last()
      rs_principle.forEach((data: any) => {
        this.fixNumber(data);
      });
      rs_last.forEach((data: any) => {
        this.fixNumber(data);
      });
      this.fixNumber(this.rs_total_income);
      this.fixNumber(this.rs_total_expenses);
      this.fixNumber(this.rs_income_expenses);
    }
  }
  //คำนวณรวมรายรับทั้งสิ้น
  sum_rs_income(data: any) {
    this.rs_total_income.oct += Number(data.oct);
    this.rs_total_income.nov += Number(data.nov);
    this.rs_total_income.dec += Number(data.dec)
    this.rs_total_income.jan += Number(data.jan)
    this.rs_total_income.feb += Number(data.feb)
    this.rs_total_income.mar += Number(data.mar)
    this.rs_total_income.apr += Number(data.apr)
    this.rs_total_income.may += Number(data.may)
    this.rs_total_income.jun += Number(data.jun)
    this.rs_total_income.jul += Number(data.jul)
    this.rs_total_income.aug += Number(data.aug)
    this.rs_total_income.sep += Number(data.sep)
    this.rs_total_income.sumRow += Number(data.sumRow)
    this.rs_total_income.q1 += Number(data.q1)
    this.rs_total_income.q2 += Number(data.q2)
    this.rs_total_income.q3 += Number(data.q3)
    this.rs_total_income.q4 += Number(data.q4)
  }
  //คำนวณรวมรายจ่ายทั้งสิ้น
  sum_rs_expenses(data: any) {
    this.rs_total_expenses.oct += Number(data.oct),
      this.rs_total_expenses.nov += Number(data.nov)
    this.rs_total_expenses.dec += Number(data.dec)
    this.rs_total_expenses.jan += Number(data.jan)
    this.rs_total_expenses.feb += Number(data.feb)
    this.rs_total_expenses.mar += Number(data.mar)
    this.rs_total_expenses.apr += Number(data.apr)
    this.rs_total_expenses.may += Number(data.may)
    this.rs_total_expenses.jun += Number(data.jun)
    this.rs_total_expenses.jul += Number(data.jul)
    this.rs_total_expenses.aug += Number(data.aug)
    this.rs_total_expenses.sep += Number(data.sep)
    this.rs_total_expenses.sumRow += Number(data.sumRow)
    this.rs_total_expenses.q1 += Number(data.q1)
    this.rs_total_expenses.q2 += Number(data.q2)
    this.rs_total_expenses.q3 += Number(data.q3)
    this.rs_total_expenses.q4 += Number(data.q4)
  }

  //calculate quarter1-4
  calQuarter(data: any) {
    data.q1 = Number(data.oct) + Number(data.nov) + Number(data.dec)
    data.q2 = Number(data.jan) + Number(data.feb) + Number(data.mar)
    data.q3 = Number(data.apr) + Number(data.may) + Number(data.jun)
    data.q4 = Number(data.jul) + Number(data.aug) + Number(data.sep)
    return data;
  }
  //func create variable sumCol
  createSumCol(data: any) {
    this.sumCol = {
      type3: data,
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      sumRow: 0,
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0
    }
    return this.sumCol;
  }
  //func calculate sum column
  calSumCol(data: any) {
    this.sumCol.q1 += Number(data.q1);
    this.sumCol.q2 += Number(data.q2);
    this.sumCol.q3 += Number(data.q3);
    this.sumCol.q4 += Number(data.q4);
    this.sumCol.oct += Number(data.oct);
    this.sumCol.nov += Number(data.nov);
    this.sumCol.dec += Number(data.dec);
    this.sumCol.jan += Number(data.jan);
    this.sumCol.feb += Number(data.feb);
    this.sumCol.mar += Number(data.mar);
    this.sumCol.apr += Number(data.apr);
    this.sumCol.may += Number(data.may);
    this.sumCol.jun += Number(data.jun);
    this.sumCol.jul += Number(data.jul);
    this.sumCol.aug += Number(data.aug);
    this.sumCol.sep += Number(data.sep);
    this.sumCol.sumRow += Number(data.sumRow);
    return this.sumCol;
  }

  //func controll display when select type mont/quarter
  select_type(ev: any) {
    this.btn_plan = false
    if (this.type_select == 'mont') {
      this.isDisplayMont = true;
      this.isDisplayQuarter = false;
    } else if (this.type_select == 'quarter') {
      this.isDisplayMont = false;
      this.isDisplayQuarter = true;
    }
  }
  //btn PDF plan
  showBtn_plan(ev: any) {
    this.btn_plan = ev;
    this.enableEdit = false;
    this.enableEditI = null;
    this.enableEditIndex = null
    this.btn_new = false
  }
  showBtn_result(ev: any) {
    this.btn_result = ev;
    this.enableEdit = false;
    this.enableEditIndex = null
    this.enableEditI = null;
    this.btn_new = false
  }
  //func convert 0 to null
  fixNumber(data: any) {
    data.oct = this.numberWithCommas(data.oct)
    data.nov = this.numberWithCommas(data.nov)
    data.dec = this.numberWithCommas(data.dec)
    data.jan = this.numberWithCommas(data.jan)
    data.feb = this.numberWithCommas(data.feb)
    data.mar = this.numberWithCommas(data.mar)
    data.apr = this.numberWithCommas(data.apr)
    data.may = this.numberWithCommas(data.may)
    data.jun = this.numberWithCommas(data.jun)
    data.jul = this.numberWithCommas(data.jul)
    data.aug = this.numberWithCommas(data.aug)
    data.sep = this.numberWithCommas(data.sep)
    data.sumRow = this.numberWithCommas(data.sumRow)
    data.q1 = this.numberWithCommas(data.q1)
    data.q2 = this.numberWithCommas(data.q2)
    data.q3 = this.numberWithCommas(data.q3)
    data.q4 = this.numberWithCommas(data.q4)
    return data;
  }
  //func fix date format to thai date
  dateThaiFormat(date: any) {
    return date = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
  //func fix comma on number
  numberWithCommas(x: any) {
    if (x == 0) {
      return null;
    }
    else {
      return Number(x);
      //return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
  //func Round decimal
  fixDecimal(x: any) {
    return Math.round(x * 100) / 100;
  }
  fixzero(data: any) {
    if (data.oct == null || data.oct == "") {
      data.oct = 0;
    }
    if (data.nov == null || data.nov ==  "") {
      data.nov = 0
    }
    if (data.dec == null || data.dec == "") {
      data.dec = 0
    }
    if (data.jan == null || data.jan == "") {
      data.jan = 0
    }
    if (data.feb == null || data.feb == "") {
      data.feb = 0
    }
    if (data.mar == null || data.mar == "") {
      data.mar = 0
    }
    if (data.apr == null || data.apr == "") {
      data.apr = 0
    }
    if (data.may == null || data.may == "") {
      data.may = 0
    }
    if (data.jun == null || data.jun == "") {
      data.jun = 0
    }
    if (data.jul == null || data.jul == "") {
      data.jul = 0
    }
    if (data.aug == null || data.aug == "") {
      data.aug = 0
    }
    if (data.sep == null || data.sep == "") {
      data.sep = 0
    }
    return data
  }

  //edit
  // //on click save update btn
  onChange(data: any) {
    this.edit_data = this.fixzero(this.edit_data);

    Swal.fire({
      title: 'ยืนยันการแก้ไข',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.services.update('m_result', Number(data.id), this.edit_data).then(async (res: any) => {
          await this.getDataAll();

          switch (this.edit_data.type1) {
            case 'รายรับ': {
              this.services.update('m_result', Number(this.principle.id), this.principle).then((res: any) => {
              })
              this.services.update('m_result', Number(this.last.id), this.last).then((res: any) => {
              })
              this.fixNumber(this.data_result.principle[0]);
              this.fixNumber(this.data_result.last[0]);
              await this.getDataAll();
              break;
            }
            case 'รายจ่าย': {
              this.services.update('m_result', Number(this.principle.id), this.principle).then((res: any) => {
              })
              this.services.update('m_result', Number(this.last.id), this.last).then((res: any) => {
              })
              this.fixNumber(this.data_result.principle[0]);
              this.fixNumber(this.data_result.last[0]);
              await this.getDataAll();
              break;
            }
            default: {
              break;
            }
          }

          Swal.fire({
            title: 'แก้ไขสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          })
          this.onClickClose();
        })
      } else {
        this.onClickClose();
      }
    })


  }
  //cal culate เงินต้นงวด/ปลายงวด
  principle_last() {
    this.principle = this.fixzero(this.data_result.principle[0])
    this.last = this.fixzero(this.rs_income_expenses)
    
    if (this.rs_total_income.oct == 0 && this.rs_total_expenses.oct == 0) {
      this.data_result.last[0].oct = 0
      this.data_result.principle[0].nov = 0
    } else {
      this.data_result.last[0].oct = Number(this.data_result.principle[0].oct) + this.rs_income_expenses.oct
      this.data_result.principle[0].nov = this.data_result.last[0].oct
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.nov == 0 && this.rs_total_expenses.nov == 0) {
      this.data_result.last[0].nov = 0
      this.data_result.principle[0].dec = 0
    } else {
      this.data_result.last[0].nov = Number(this.data_result.principle[0].nov) + this.rs_income_expenses.nov
      this.data_result.principle[0].dec = this.data_result.last[0].nov
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.dec == 0 && this.rs_total_expenses.dec == 0) {
      this.data_result.last[0].dec = 0
      this.data_result.principle[0].jan = 0
    } else {
      this.data_result.last[0].dec = Number(this.data_result.principle[0].dec) + this.rs_income_expenses.dec
      this.data_result.principle[0].jan = this.data_result.last[0].dec
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.jan == 0 && this.rs_total_expenses.jan == 0) {
      this.data_result.last[0].jan = 0
      this.data_result.principle[0].feb = 0
    } else {
      this.data_result.last[0].jan = Number(this.data_result.principle[0].jan) + this.rs_income_expenses.jan
      this.data_result.principle[0].feb = this.data_result.last[0].jan
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.feb == 0 && this.rs_total_expenses.feb == 0) {
      this.data_result.last[0].feb = 0
      this.data_result.principle[0].mar = 0
    } else {
      this.data_result.last[0].feb = Number(this.data_result.principle[0].feb) + this.rs_income_expenses.feb
      this.data_result.principle[0].mar = this.data_result.last[0].feb
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.mar == 0 && this.rs_total_expenses.mar == 0) {
      this.data_result.last[0].mar = 0
      this.data_result.principle[0].apr = 0
    } else {
      this.data_result.last[0].mar = Number(this.data_result.principle[0].mar) + this.rs_income_expenses.mar
      this.data_result.principle[0].apr = this.data_result.last[0].mar
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.apr == 0 && this.rs_total_expenses.apr == 0) {
      this.data_result.last[0].apr = 0
      this.data_result.principle[0].may = 0
    } else {
      this.data_result.last[0].apr = Number(this.data_result.principle[0].apr) + this.rs_income_expenses.apr
      this.data_result.principle[0].may = this.data_result.last[0].apr
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.may == 0 && this.rs_total_expenses.may == 0) {
      this.data_result.last[0].may = 0
      this.data_result.principle[0].jun = 0
    } else {
      this.data_result.last[0].may = Number(this.data_result.principle[0].may) + this.rs_income_expenses.may
      this.data_result.principle[0].jun = this.data_result.last[0].may
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.jun == 0 && this.rs_total_expenses.jun == 0) {
      this.data_result.last[0].jun = 0
      this.data_result.principle[0].jul = 0
    } else {
      this.data_result.last[0].jun = Number(this.data_result.principle[0].jun) + this.rs_income_expenses.jun
      this.data_result.principle[0].jul = this.data_result.last[0].jun
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.jul == 0 && this.rs_total_expenses.jul == 0) {
      this.data_result.last[0].jul = 0
      this.data_result.principle[0].aug = 0
    } else {
      this.data_result.last[0].jul = Number(this.data_result.principle[0].jul) + this.rs_income_expenses.jul
      this.data_result.principle[0].aug = this.data_result.last[0].jul
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.aug == 0 && this.rs_total_expenses.aug == 0) {
      this.data_result.last[0].aug = 0
      this.data_result.principle[0].sep = 0
    } else {
      this.data_result.last[0].aug = Number(this.data_result.principle[0].aug) + this.rs_income_expenses.aug
      this.data_result.principle[0].sep = this.data_result.last[0].aug
    }
    this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])

    if (this.rs_total_income.sep == 0 && this.rs_total_expenses.sep == 0) {
      this.data_result.last[0].sep = 0
    } else {
      this.data_result.last[0].sep = Number(this.data_result.principle[0].sep) + this.rs_income_expenses.sep
      this.data_result.principle[0] = this.fixzero(this.data_result.principle[0])
    }

  }
  //on click edit btn
  onClickEdit(data: any, i: any) {
    if (data.type2 == "เงินให้สนับสนุน") {
      this.enableEditIndex = null;
      this.enableEditI = i
    } else {
      this.enableEditI = null
      this.enableEditIndex = i;
    }
    this.enableEdit = true;
    this.edit_data = {
      fiscal_year: data.fiscal_year,
      type1: data.type1,
      type2: data.type2,
      type3: data.type3,
      oct: (data.oct),
      nov: (data.nov),
      dec: (data.dec),
      jan: (data.jan),
      feb: (data.feb),
      mar: (data.mar),
      apr: (data.apr),
      may: (data.may),
      jun: (data.jun),
      jul: (data.jul),
      aug: (data.aug),
      sep: (data.sep),
      status: data.status,
      user_id: Number(this.admin_data.id),
      id_plan: Number(data.id_plan),
    }
    // document.getElementById("oct")!.contentEditable = "true";
  }
  //on click close btn
  onClickClose() {
    this.enableEdit = false
    this.enableEditIndex = null
    this.enableEditI = null
    this.edit_data = {
      fiscal_year: '',
      type1: '',
      type2: '',
      type3: '',
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      status: '',
      user_id: 0,
      id_plan: 0,
    }
    // document.getElementById("oct")!.contentEditable = "false";
  }

  //new
  save_new(type1: any, type2: any) {
    this.new_data.fiscal_year = this.years_select
    this.new_data.type1 = type1
    this.new_data.type2 = type2
    this.new_data = this.fixzero(this.new_data);
    
    Swal.fire({
      title: 'ยืนยันการเพิ่มรายการใหม่',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      this.services.create('m_result', this.new_data).then((res: any) => {
        this.getDataAll()
        this.close_new()
        Swal.fire({
          title: 'บันทึกสำเร็จ',
          icon: 'success'
        })
      })
    })
  }
  close_new() {
    this.btn_new = false
    this.btn_newLoan = false
    this.new_data = {
      fiscal_year: '',
      type1: '',
      type2: '',
      type3: '',
      oct: 0,
      nov: 0,
      dec: 0,
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      status: 'Enable',
      user_id: 0,
      id_plan: 0,
    }
  }
  onChangeTab() {
    this.enableEdit = false
    this.btn_new = false
  }
  delete_new(data: any) {
    this.fixzero(data)
    data.status = "Disable"

    Swal.fire({
      title: 'ยืนยันการลบ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.services.update('m_result', Number(data.id), data).then((res: any) => {
          this.getDataAll()
          Swal.fire({
            title: 'ลบสำเร็จ',
            icon: 'success'
          })
        })
      }

    })
  }

  //full page table
  maximizeorMinimize(table: any, btn: any) {
    this.services.maximizeorMinimize(table, btn, this.maximized)
    this.maximized = this.services.switchMaximize(this.maximized);
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  onClickListMenu() {
    document.getElementById('finances')!.classList.remove('active');
    document.getElementById('finance')!.classList.remove('show');
    // document.getElementById('plans')!.classList.remove('active');
    document.getElementById('plan')!.classList.remove('show');
    document.getElementById('receivables')!.classList.remove('active');
    document.getElementById('receivable')!.classList.remove('show');
  }
}
